module.exports = __webpack_public_path__ + "static/media/Banner-Mobile.7177712b.png";